module.exports = __webpack_public_path__ + "img/TMFAsafe.f5cf3c80.png";